"use client";

import { useXPixel, XPixelIds } from "@/hooks/use-x-pixel";
import { useSession } from "next-auth/react";
import Link from "next/link";
import React from "react";

export function JoinDiscordLink({
  children,
  ...props
}: React.ComponentProps<typeof Link>) {
  const { trackEvent } = useXPixel();
  const { data: session } = useSession();

  const track = () => {
    trackEvent(
      XPixelIds.leadJoinDiscord,
      session?.user.email ? { email_address: session.user.email } : undefined,
    );
  };

  return (
    <Link {...props} onClick={track}>
      {children}
    </Link>
  );
}
